import {useState} from 'react'

import * as localStorage from '../../../commons/src/services/local-storage'

const useLocalStorageState = <T>(key: string, initialValue: T): [T, (value: T) => void] => {
  const initialItem: T | null = localStorage.getItem(key)
  const [state, setState] = useState(initialItem === null ? initialValue : initialItem)

  const set = (value: T) => {
    setState(value)
    localStorage.setItem(key, value)
  }

  return [state, set]
}

export default useLocalStorageState
